import { render, staticRenderFns } from "./LoginMongolia.vue?vue&type=template&id=4904e809&scoped=true"
import script from "./LoginMongolia.vue?vue&type=script&lang=js"
export * from "./LoginMongolia.vue?vue&type=script&lang=js"
import style0 from "./LoginMongolia.vue?vue&type=style&index=0&id=4904e809&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904e809",
  null
  
)

export default component.exports